<template>
  <Transition
    enter-active-class="transition-all duration-300 ease-out"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="transition-all duration-200 ease-in"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div v-if="isOpen && card" class="fixed inset-0 w-full h-full bg-cw-dark-alt/95 pt-30 lg:pt-20 heightMd:pt-10 z-100">
      <div class="flex w-full h-full items-center justify-center">
        <div class="flex justify-center items-start">
          <GameCardItem class="2xl:w-60 2xl:h-85 xl:w-35 xl:h-48 lg:w-28 lg:h-40 w-22 h-30" :card />
          <div class="relative sm:max-w-[300px] md:max-w-[500px] bg-cw-dark rounded-[13px] px-5 pt-5 pb-6 md:px-10 md:pt-10 md:pb-12 ml-4 md:ml-8 xl:ml-10">
            <h1 class="text-base md:text-lg lg:text-2xl font-bold text-white mb-4" v-if="card.type">{{ card.type }}</h1>
            <p class="text-left mb-7 heightMd:mb-5 font-normal tracking-normal heightMd:text-[14px] text-[16px] sm:text-[14px] text-[#999999]" v-if="card.text">{{ card.text }}</p>
          </div>
        </div>
      </div>
      <div @click="close" class="absolute inset-0 z-1"></div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import GameCardItem from '@/components/game-play/GameCardItem.vue'
import { useGameStore } from '@/stores/game'
import type { CardT } from '@/types/Game'
import { storeToRefs } from 'pinia'
import { ref, watch } from 'vue'

const card = ref<CardT | null>(null)
const isOpen = ref(false)
const { isTurn } = storeToRefs(useGameStore())

const open = (crd: CardT) => {
  card.value = crd
  isOpen.value = true
}

const close = () => {
  isOpen.value = false
}

watch(isTurn, (newValue: boolean) => {
  if (!newValue && isOpen.value) {
    close()
  }
})

defineExpose({ open, close })
</script>

<style scoped></style>
